import React, { useState } from 'react';
import { Button, Dropdown } from '@fourthwall/components';
import { CalendarIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
import * as S from './AnalyticsDropdown.styled';
export const AnalyticsDropdown = ({ tabs }) => {
    const [isOpen, setIsOpen] = useState(false);
    const currentTab = tabs.options.find((option) => option.value === tabs.value) || tabs.options[0];
    const currentLabel = currentTab?.label || '';
    const handleOptionClick = (value) => {
        tabs.onChange(value);
        setIsOpen(false);
    };
    const dropdownContent = (React.createElement(S.DropdownContent, null,
        tabs.options.map((option) => (React.createElement(Dropdown.Item, { key: option.value, label: option.label, active: option.value === tabs.value, onClick: () => handleOptionClick(option.value), cursor: "pointer" }))),
        React.createElement(Dropdown.Divider, null),
        React.createElement(Dropdown.Item, { label: "View all analytics", to: routing.analytics.overview.self })));
    return (React.createElement(Dropdown, { content: dropdownContent, position: "bottom-start", maxWidth: 280, isOpen: isOpen, onClose: () => setIsOpen(false) },
        React.createElement(Button, { size: "xsmall", appearance: "secondary", label: currentLabel, leftIcon: React.createElement(CalendarIcon, null), onClick: () => setIsOpen(!isOpen) })));
};
